module.exports = __webpack_public_path__ + "assets/img/8_1104.f0af4342.jpg";